import React, { useCallback } from 'react'
import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayManifestKeys from '../../../constants/locale/key/AceHighwayManifest'
import AceHighwayResponseKeys from '../../../constants/locale/key/AceHighwayResponse'

const ACEHighwayManifestTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.ACE_HIGHWAY_MANIFEST,
        Namespace.ACE_HIGHWAY_RESPONSE
    ])

    let aceHighwayManifest = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TITLE)
    let aceHighwayTruckConveyance = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRUCK_CONVEYANCE_TITLE)
    let id = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ID)
    let headerId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.HEADER_ID)
    let createdBy = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATED_BY)
    let createdDate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATED_DATE)
    let updatedBy = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.UPDATED_BY)
    let updatedDate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.UPDATED_DATE)
    let submittedBy = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SUBMITTED_BY)
    let submittedDate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SUBMITTED_DATE)
    let version = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.VERSION)
    let partyId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PARTY_ID)
    let carrierScac = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CARRIER_SCAC)
    let tripNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRIP_NO)
    let arrivalDate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ARRIVAL_DATE)
    let arrivalDateOnly = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ARRIVAL_DATE_ONLY)
    let arrivalTime = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ARRIVAL_TIME)
    let transitIndicator = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRANSIT_INDICATOR)
    let firstExpectedPort = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FIRST_EXPECTED_PORT)
    let borderCrossing = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.BORDER_CROSSING)
    let messageFunction = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MSG_FUNCTION)
    let amendmentCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.AMENDMENT_CODE)
    let status = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS)
    let paxlstPrevStatus = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_PREV_STATUS)
    let paxlstStatus = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_STATUS)
    let responseDate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.RESPONSE_DATE)
    let templateFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TEMPLATE_FLAG)
    let templateName = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TEMPLATE_NAME)
    let fetchTruck = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FETCH_TRUCK)
    let aceId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACE_ID)
    let aceFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACE_FLAG)
    let conveyanceId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_ID)
    let conveyanceNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_NO)
    let conveyanceType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_TYPE)
    let email = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EMAIL)
    let vin = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.VIN)
    let dotNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DOT_NO)
    let transponderId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRANSPONDER_ID)
    let saveTruckFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SAVE_TRUCK_FLAG)
    let truckId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRUCK_ID)
    let licensePlateNo1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_NO1)
    let licensePlateCountry1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_COUNTRY1)
    let licensePlateState1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_STATE1)
    let licensePlateNo2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_NO2)
    let licensePlateCountry2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_COUNTRY2)
    let licensePlateState2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_STATE2)
    let licensePlateNo3 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_NO3)
    let licensePlateCountry3 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_COUNTRY3)
    let licensePlateState3 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_STATE3)
    let licensePlateNo4 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_NO4)
    let licensePlateCountry4 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_COUNTRY4)
    let licensePlateState4 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_STATE4)
    let iitCode1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IIT_CODE1)
    let iitCode2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IIT_CODE2)
    let iitCode3 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IIT_CODE3)
    let iitCode4 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IIT_CODE4)
    let sealNo1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO1)
    let sealNo2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO2)
    let sealNo3 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO3)
    let sealNo4 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO4)
    let sealNo5 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO5)
    let sealNo6 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO6)
    let sealNo7 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO7)
    let sealNo8 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO8)
    let sealNo9 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NO9)
    let integration = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.INTEGRATION)
    let equipmentInfo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EquipmentInfo.TITLE)
    let equipmentId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EquipmentInfo.EQUIPMENT_ID)
    let equipmentAceId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EquipmentInfo.EQUIPMENT_ACE_ID)
    let equipmentType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EquipmentInfo.EQUIPMENT_TYPE)
    let equipmentNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EquipmentInfo.EQUIPMENT_NO)
    let insuranceInfo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InsuranceInfo.TITLE)
    let insuranceCompany = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InsuranceInfo.INSURANCE_COMPANY)
    let insurancePolicyNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InsuranceInfo.INSURANCE_POLICY_NO)
    let liabilityAmount = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InsuranceInfo.LIABILITY_AMOUNT)
    let yearOfIssuance = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InsuranceInfo.YEAR_OF_ISSUANCE)
    let partyInfo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.TITLE)
    let conveyanceRemark = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_REMARK)
    let paxlstRemark = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_REMARK)
    let paxlstHelper1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_HELPER_1)
    let paxlstDialogInfo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_DIALOG_INFO)
    let fetchCrew = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FETCH_CREW)
    let saveCrewFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SAVE_CREW_FLAG)
    let saveButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SAVE_BUTTON)
    let updateButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.UPDATE_BUTTON)
    let autoSubmitPaxlst = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.AUTO_SUBMIT_PAXLST)
    let autoConfirmManifest = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.AUTO_CONFIRM_MANIFEST)
    let tripInformation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRIP_INFORMATION)
    let mandatoryFields = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MANDATORY_FIELDS)
    let inBondSeqRunningOut1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IN_BOND_SEQ_RUNNING_OUT_1)
    let inBondSeqRunningOut2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IN_BOND_SEQ_RUNNING_OUT_2)
    let truckConveyance = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRUCK_CONVEYANCE)
    let withAceNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.WITH_ACE_NO)
    let withoutAceNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.WITHOUT_ACE_NO)
    let note = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE)
    let additionalLicensePlates = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_LICENSE_PLATES)
    let sealNos = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEAL_NOS)
    let instrumentsOfInternationalTraffic = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.INSTRUMENTS_OF_INTERNATIONAL_TRAFFIC)
    let addNew = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADD_NEW)
    let crewInformation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREW_INFORMATION)
    let add = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADD)
    let clone = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CLONE)
    //let delete = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DELETE)
    let entries = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ENTRIES)
    let accepted = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACCEPTED)
    let rejected = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REJECTED)
    let draft = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DRAFT)
    let sent = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SENT)
    let pendingResubmission = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PENDING_RESUBMISSION)
    let cancelled = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CANCELLED)
    let modificationRejected = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MODIFICATION_REJECTED)
    let reviewed = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REVIEWED)
    let pendingReview = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PENDING_REVIEW)
    let reviewInProgress = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REVIEW_IN_PROGRESS)
    let paxLstInformation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_INFORMATION)
    let createTrip = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATE_TRIP)
    let equipmentInformation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EQUIPMENT_INFORMATION)
    let insuranceInformation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.INSURANCE_INFORMATION)
    let addManifest = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADD_MANIFEST)
    let licensePlateNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE_NO)
    let countryRegistration = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.COUNTRY_REGISTRATION)
    let provinceStateRegionRegistration = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PROVINCE_STATE_REGION_REGISTRATION)
    let conveyanceTemplate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_TEMPLATE)
    let submitSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SUBMIT_SUCCESS_MSG)
    let addShipments = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADD_SHIPMENTS)
    let setStatusNotification = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SET_STATUS_NOTIFICATION)
    let viewLogsAndHistory = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.VIEW_LOGS_AND_HISTORY)
    let templateAppliedSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TEMPLATE_APPLIED_SUCCESS_MSG)
    let createdSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATED_SUCCESS_MSG)
    let discardButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DISCARD_BUTTON)
    let saveAndContinueButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SAVE_AND_CONTINUE_BUTTON)
    let failToSubmitPaxlstMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FAIL_TO_SUBMIT_PAXLST_MSG)
    let createAciManifestButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATE_ACI_MANIFEST_BUTTON)
    let skipButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SKIP_BUTTON)
    let submitManifestButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SUBMIT_MANIFEST_BUTTON)
    let discardConfirmationMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DISCARD_CONFIRMATION_MSG)
    let discardConfirmButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DISCARD_CONFIRM_BUTTON)
    let continueEditingButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONTINUE_EDITING_BUTTON)
    let discardTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DISCARD_TITLE)
    let conveyanceWithAceNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_WITH_ACE_NO)
    let conveyanceWithoutAceNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONVEYANCE_WITHOUT_ACE_NO)
    let documentType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DOCUMENT_TYPE)
    let documentNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DOCUMENT_NO)
    let address = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDRESS)
    let noteClearedSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_CLEARED_SUCCESS_MSG)
    let noteUpdatedSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_UPDATED_SUCCESS_MSG)
    let noteSaveFailedMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_SAVE_FAILED_MSG)
    let noteClearFailedMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_CLEAR_FAILED_MSG)
    let max300Characters = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MAX_300_CHARACTERS)
    let invalidCharacterFound = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.INVALID_CHARACTER_FOUND)
    let resetNoteButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.RESET_NOTE_BUTTON)
    let reminderNotes = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REMINDER_NOTES)
    let createdDateEST = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATED_DATE_EST)
    let username = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.USERNAME)
    let reminderNote = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REMINDER_NOTE)
    let noteForManifest = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_FOR_MANIFEST)
    let activityLogTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACTIVITYLOG_TITLE)
    //let createdDate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATED_DATE_TIME)
    let loginUserId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LOGIN_USER_ID)
    let functionCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FUNCTION_CODE)
    let auditDescription = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.AUDIT_DESC)
    let vinNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.VIN)
    let emailTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EMAIL_COVERSHEET)
    let sendButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEND_BUTTON)
    let sendCoverSheetSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEND_COVER_SHEET_SUCCESS_MSG)
    let sendCoverSheetFailedMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEND_COVER_SHEET_FAILED_MSG)
    let emailSubject = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EMAIL_SUBJECT)
    let emailMessage = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EMAIL_MESSAGE)
    let additionalIITHideText = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_IIT_HIDE_TEXT)
    let additionalIITShowText = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_IIT_SHOW_TEXT)
    let additionalIITFooterText = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_IIT_FOOTER_TEXT)
    let searchInYourEntries = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEARCH_IN_YOUR_ENTRIES)
    let addEquipment = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADD_EQUIPMENT)
    let action = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACTION)
    let licensePlates = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATES)
    let equipmentInfoTemplate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EQUIPMENT_INFO_TEMPLATE)
    let saveEquipmentFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SAVE_EQUIPMENT_FLAG)
    let fetchEquipment = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FETCH_EQUIPMENT)
    let additionalSealNoHideText = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_SEAL_NO_HIDE_TEXT)
    let additionalSealNoShowText = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_SEAL_NO_SHOW_TEXT)
    let additionalSealNoFooterText = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADDITIONAL_SEAL_NO_FOOTER_TEXT)
    let licensePlate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.LICENSE_PLATE)
    let crewTemplate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREW_TEMPLATE)
    let dropOffLocationPartyTemplate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DROP_OFF_LOCATION_PARTY_TEMPLATE)
    let personalInformationIsRequiredMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PERSONAL_INFORMATION_IS_REQUIRED_MSG)
    let required = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REQUIRED)
    let minOneLicenseIsRequiredMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MIN_ONE_LICENSE_IS_REQUIRED_MSG)
    let male = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MALE)
    let female = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FEMALE)
    let x = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.X)
    let deleteButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DELETE_BUTTON)
    let cloneButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CLONE_BUTTON)
    let editButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EDIT_BUTTON)
    let noRecorsToDisplay = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NO_RECORDS_TO_DISPLAY)
    let aceManifestShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayManifestKeys.TITLE)
    let transactionUnsuccessful = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRANSACTION_UNSUCCESSFUL)
    let statusNotificationUpdated = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_NOTIFICATION_UPDATED)
    let deleteSucceeded = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DELETE_SUCCEEDED)
    let orCloneThePreviousOne = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.OR_CLONE_THE_PREVIOUS_ONE)
    let addStatusNotification = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ADD_STATUS_NOTIFICATION)
    let backButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.BACK_BUTTON)
    let continueButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CONTINUE_BUTTON)
    let deleteConfirmationMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DELETE_CONFIRMATION_MSG)
    let deleteConfirmButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DELETE_CONFIRM_BUTTON)
    let deleteCancelButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DELETE_CANCEL_BUTTON)
    let noteContent = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_CONTENT)
    let faxTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FAX_COVERSHEET)
    let noteFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NOTE_FLAG)
    let driver = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.DRIVER)
    let truck = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRUCK)
    let trailer = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRAILER)
    let reviewStatus = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.REVIEW_STATUS)
    let cancelButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CANCEL_BUTTON)
    let printManifestShipment = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PRINT_MANIFEST_SHIPMENT)
    let printCoverSheet = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PRINT_COVERSHEET)
    let printCoverSheetWithQRCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PRINT_COVERSHEET_WITH_QR_CODE)
    let emailCoverSheet = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EMAIL_COVERSHEET)
    let emailCoverSheetWithQRCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EMAIL_COVERSHEET_WITH_QR_CODE)
    let faxCoverSheet = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FAX_COVERSHEET)
    let faxCoverSheetWithQRCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.FAX_COVERSHEET_WITH_QR_CODE)
    let printCoverSheetSummary = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PRINT_COVERSHEET_SUMMARY)
    let print7533 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PRINT_7533)
    let print7512 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PRINT_7512)
    let quickGlanceAtShipment = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.QUICK_GLANCE_AT_SHIPMENT)
    let okButton = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.OK_BUTTON)
    let pendingEntryNumber = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PENDING_ENTRY_NUMBER)
    let portMismatch = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PORT_MISMATCH)
    let statusDraft = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_DRAFT)
    let statusAccepted = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_ACCEPTED)
    let statusSent = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_SENT)
    let statusRejected = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_REJECTED)
    let statusPreliminary = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_PRELIMINARY)
    let statusStatusNotification = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_STATUS_NOTIFICATION)
    let statusCancellationAccepted = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_CANCELLATION_ACCEPTED)
    let statusCancellationRejected = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_CANCELLATION_REJECTED)
    let statusModificationRejected = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_MODIFICATION_REJECTED)
    let statusTripArrived = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_TRIP_ARRIVED)
    let statusTripReleased = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.STATUS_TRIP_RELEASED)
    let importation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.IMPORTATION)
    let exportation = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EXPORTATION)
    let transit = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRANSIT)
    let createManifest = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREATE_MANIFEST)
    let goToSubmit = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.GO_TO_SUBMIT)
    let partyAceId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.ACE_ID)
    let noRecordsToDisplay = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.NO_RECORDS_TO_DISPLAY)
    let accountNameAndOr = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.ACCOUNT_NAME_AND_OR)
    let totalNoOfShipmentIn = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TOTAL_NO_OF_SHIPMENT_IN)
    let shipment = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SHIPMENT)
    let updateShipmentInfo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.UPDATE_SHIPMENT_INFO)
    let useTemplate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.USE_TEMPLATE)
    let sendCoverSheetSuccessfulMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.SEND_COVER_SHEET_SUCCESSFUL_MSG)
    let manifestTemplate = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MANIFEST_TEMPLATE)
    let cancelMultipleRecords = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CANCEL_MULTIPLE_RECORDS)
    let viewResponses = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.VIEW_RESPONSES)
    let submitPAXLSTButton = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.SUBMIT_PAXLST_BUTTON)
    let fax = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.FAX)
    let faxRemark = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.FAX_REMARK)
    let editSentRecords = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.EDIT_SENT_RECORDS)
    let deleteDraftRecords = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.DELETE_DRAFT_RECORDS)
    let manifestCancelled = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.MANIFEST_CANCELLED)
    let populatePAXLSTButton = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.POPULATE_PAXLST_BUTTON)
    let populatePAXLSTNote = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.POPULATE_PAXLST_NOTE)
    let populatePAXLSTQuestion = translate(Namespace.ACE_HIGHWAY_MANIFEST,AceHighwayManifestKeys.POPULATE_PAXLST_QUESTION)

    let tripResponseTitle = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponseKeys.TRIP_RESPONSE_TITLE)
    let shipmentResponseTitle = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponseKeys.SHIPMENT_RESPONSE_TITLE)
    let paxlstResponseTitle = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponseKeys.PAXLST_RESPONSE_TITLE)
    let manifestResponseTitle = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponseKeys.MANIFEST_RESPONSE_TITLE)

    let manifestTableTripNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MANIFEST_TABLE.TRIP_NO)
    let manifestTableShipmentStatusScn = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MANIFEST_TABLE.SHIPMENT_STATUS_SCN)
    let manifestTableTransitEta = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MANIFEST_TABLE.TRANSIT_ETA)
    let tripSectionHelper = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRIP_SECTION_HELPER)
    let truckSectionHelper = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.TRUCK_SECTION_HELPER)
    let equipmentSectionHelper = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EQUIPMENT_SECTION_HELPER)
    let insuranceSectionHelper = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.INSURANCE_SECTION_HELPER)
    let crewSectionHelper = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.CREW_SECTION_HELPER)
    let paxLstSectionHelper = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_SECTION_HELPER)

    let partyInfoDetailTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PARTY_INFO_DETAIL_TITLE)
    let partyInfoAddressTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PARTY_INFO_ADDRESS_TITLE)
    let partyInfoLicenseTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PARTY_INFO_LICENSE_TITLE)
    let partyInfoDocumentTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PARTY_INFO_DOCUMENT_TITLE)
    let paxlstInfoAddressTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PAXLST_INFO_ADDRESS_TITLE)

    let manifestHeaderId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.MANIFEST_HEADER_ID)
    let shipmentHeaderId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.SHIPMENT_HEADER_ID)
    let dob = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.DOB)
    let gender = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.GENDER)
    let crewType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CREW_TYPE)
    let partyType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PARTY_TYPE)
    let partyIdentifier = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PARTY_IDENTIFIER)
    let partyIdentifierCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PARTY_IDENTIFIER_CODE)
    let partyIdentifierValue = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PARTY_IDENTIFIER_VALUE)
    let name = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.NAME)
    let name1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.NAME1)
    let name2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.NAME2)
    let partyDropDown = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PARTY_DROP_DOWN)
    let address1 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.ADDRESS1)
    let address2 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.ADDRESS2)
    let address3 = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.ADDRESS3)
    let cityName = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CITY_NAME)
    let postalCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.POSTAL_CODE)
    let country = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.COUNTRY)
    let state = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.STATE)
    let telNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.TEL_NO)
    let ctpatInd = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CTPAT_IND)
    let hazmatEndorsement = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.HAZMAT_ENDORSEMENT)
    let licenseNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.LICENSE_NO)
    let licenseCountry = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.LICENSE_COUNTRY)
    let licenseState = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.LICENSE_STATE)
    let cdlNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CDL_NO)
    let cdlCountry = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CDL_COUNTRY)
    let cdlState = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CDL_STATE)
    let routingCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.ROUTING_CODE)
    let brokerDownloadRefNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.BROKER_DOWNLOAD_REF_NO)
    let portOfLoading = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PORT_OF_LOADING)
    let firstName = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.FIRST_NAME)
    let middleName = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.MIDDLE_NAME)
    let lastName = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.LAST_NAME)
    let aceIdFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.ACE_ID_FLAG)
    let fastCard = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.FAST_CARD)
    let crewId = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.CREW_ID)
    let portCode = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.PORT_CODE)
    let fastCardFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.FAST_CARD_FLAG)
    let saveFlag = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.SAVE_FLAG)
    let nationality = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.PartyInfo.NATIONALITY)

    let internationalDoc = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InternationalDoc.TITLE)
    let docType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InternationalDoc.DOC_TYPE)
    let docNo = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InternationalDoc.DOC_NO)
    let docCountry = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InternationalDoc.COUNTRY)
    let docState = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.InternationalDoc.STATE)

    let statusNotificationTitle = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.TITLE)
    //let name = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.NAME)
    let snType = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.SN_TYPE)
    let shipmentControlNum = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.SHIPMENT_CONTROL_NUM)
    //let email = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.EMAIL)
    let mobileNum = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.MOBILE_NUM)
    let faxNum = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.StatusNotification.FAX_NUM)

    let max100RecordsPerExport = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MAX_100_RECORDS_PER_EXPORT)
    let exportManifestInBackground = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EXPORT_MANIFEST_IN_BACKGROUND)
    let exportManifest = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.EXPORT_MANIFEST)
    let massDelete = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MASS_DELETE)
    let massDeleteInProgress = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MASS_DELETE_IN_PROGRESS)
    let massDeleteSuccessMsg = translate(Namespace.ACE_HIGHWAY_MANIFEST, AceHighwayManifestKeys.MASS_DELETE_SUCCESS_MSG)

    return {
        aceHighwayManifest,
        aceHighwayTruckConveyance,
        id,
        headerId,
        createdBy,
        createdDate,
        updatedBy,
        updatedDate,
        submittedBy,
        submittedDate,
        version,
        partyId,
        carrierScac,
        tripNo,
        arrivalDate,
        arrivalDateOnly,
        arrivalTime,
        transitIndicator,
        firstExpectedPort,
        borderCrossing,
        messageFunction,
        amendmentCode,
        status,
        paxlstPrevStatus,
        paxlstStatus,
        responseDate,
        templateFlag,
        templateName,
        fetchTruck,
        aceId,
        aceFlag,
        conveyanceId,
        conveyanceNo,
        conveyanceType,
        email,
        vin,
        dotNo,
        transponderId,
        saveTruckFlag,
        truckId,
        licensePlateNo1,
        licensePlateCountry1,
        licensePlateState1,
        licensePlateNo2,
        licensePlateCountry2,
        licensePlateState2,
        licensePlateNo3,
        licensePlateCountry3,
        licensePlateState3,
        licensePlateNo4,
        licensePlateCountry4,
        licensePlateState4,
        iitCode1,
        iitCode2,
        iitCode3,
        iitCode4,
        sealNo1,
        sealNo2,
        sealNo3,
        sealNo4,
        sealNo5,
        sealNo6,
        sealNo7,
        sealNo8,
        sealNo9,
        integration,
        equipmentInfo,
        equipmentId,
        equipmentAceId,
        equipmentType,
        equipmentNo,
        insuranceInfo,
        insuranceCompany,
        insurancePolicyNo,
        liabilityAmount,
        yearOfIssuance,
        partyInfo,
        conveyanceRemark,
        paxlstRemark,
        paxlstHelper1,
        paxlstDialogInfo,
        fetchCrew,
        saveCrewFlag,
        saveButton,
        updateButton,
        autoSubmitPaxlst,
        autoConfirmManifest,
        tripInformation,
        mandatoryFields,
        inBondSeqRunningOut1,
        inBondSeqRunningOut2,
        truckConveyance,
        withAceNo,
        withoutAceNo,
        note,
        additionalLicensePlates,
        sealNos,
        instrumentsOfInternationalTraffic,
        addNew,
        crewInformation,
        add,
        clone,
        entries,
        accepted,
        rejected,
        draft,
        sent,
        pendingResubmission,
        cancelled,
        modificationRejected,
        reviewed,
        pendingReview,
        reviewInProgress,
        paxLstInformation,
        createTrip,
        equipmentInformation,
        insuranceInformation,
        addManifest,
        licensePlateNo,
        countryRegistration,
        provinceStateRegionRegistration,
        conveyanceTemplate,
        submitSuccessMsg,
        addShipments,
        setStatusNotification,
        viewLogsAndHistory,
        templateAppliedSuccessMsg,
        createdSuccessMsg,
        discardButton,
        saveAndContinueButton,
        failToSubmitPaxlstMsg,
        createAciManifestButton,
        skipButton,
        submitManifestButton,
        discardConfirmationMsg,
        discardConfirmButton,
        continueEditingButton,
        discardTitle,
        conveyanceWithAceNo,
        conveyanceWithoutAceNo,
        documentType,
        documentNo,
        address,
        noteClearedSuccessMsg,
        noteUpdatedSuccessMsg,
        noteSaveFailedMsg,
        noteClearFailedMsg,
        max300Characters,
        invalidCharacterFound,
        resetNoteButton,
        reminderNotes,
        createdDateEST,
        username,
        reminderNote,
        noteForManifest,
        activityLogTitle,
        //createdDate,
        loginUserId,
        functionCode,
        auditDescription,
        vinNo,
        emailTitle,
        sendButton,
        sendCoverSheetSuccessMsg,
        sendCoverSheetFailedMsg,
        emailSubject,
        emailMessage,
        additionalIITHideText,
        additionalIITShowText,
        additionalIITFooterText,
        searchInYourEntries,
        addEquipment,
        action,
        licensePlates,
        equipmentInfoTemplate,
        saveEquipmentFlag,
        fetchEquipment,
        additionalSealNoHideText,
        additionalSealNoShowText,
        additionalSealNoFooterText,
        licensePlate,
        crewTemplate,
        dropOffLocationPartyTemplate,
        personalInformationIsRequiredMsg,
        required,
        minOneLicenseIsRequiredMsg,
        male,
        female,
        x,
        deleteButton,
        cloneButton,
        editButton,
        noRecorsToDisplay,
        aceManifestShipment,
        transactionUnsuccessful,
        statusNotificationUpdated,
        deleteSucceeded,
        orCloneThePreviousOne,
        addStatusNotification,
        backButton,
        continueButton,
        deleteConfirmationMsg,
        deleteConfirmButton,
        deleteCancelButton,
        noteContent,
        faxTitle,
        noteFlag,
        driver,
        truck,
        trailer,
        reviewStatus,
        cancelButton,
        printManifestShipment,
        printCoverSheet,
        printCoverSheetWithQRCode,
        emailCoverSheet,
        emailCoverSheetWithQRCode,
        faxCoverSheet,
        faxCoverSheetWithQRCode,
        printCoverSheetSummary,
        print7533,
        print7512,
        quickGlanceAtShipment,
        okButton,
        pendingEntryNumber,
        portMismatch,
        statusDraft,
        statusAccepted,
        statusSent,
        statusRejected,
        statusPreliminary,
        statusStatusNotification,
        statusCancellationAccepted,
        statusCancellationRejected,
        statusModificationRejected,
        statusTripArrived,
        statusTripReleased,
        importation,
        exportation,
        transit,
        createManifest,
        goToSubmit,
        partyAceId,
        noRecordsToDisplay,
        accountNameAndOr,
        totalNoOfShipmentIn,
        shipment,
        updateShipmentInfo,
        useTemplate,
        sendCoverSheetSuccessfulMsg,
        manifestTemplate,
        cancelMultipleRecords,
        viewResponses,
        submitPAXLSTButton,
        fax,
        faxRemark,
        editSentRecords,
        deleteDraftRecords,
        manifestCancelled,
        populatePAXLSTButton,
        populatePAXLSTNote,
        populatePAXLSTQuestion,

        tripResponseTitle,
        shipmentResponseTitle,
        paxlstResponseTitle,
        manifestResponseTitle,

        manifestTableTripNo,
        manifestTableShipmentStatusScn,
        manifestTableTransitEta,
        tripSectionHelper,
        truckSectionHelper,
        equipmentSectionHelper,
        insuranceSectionHelper,
        crewSectionHelper,
        paxLstSectionHelper,

        partyInfoDetailTitle,
        partyInfoAddressTitle,
        partyInfoLicenseTitle,
        partyInfoDocumentTitle,
        paxlstInfoAddressTitle,

        manifestHeaderId,
        shipmentHeaderId,
        dob,
        gender,
        crewType,
        partyType,
        partyIdentifier,
        partyIdentifierCode,
        partyIdentifierValue,
        name,
        name1,
        name2,
        partyDropDown,
        address1,
        address2,
        address3,
        cityName,
        postalCode,
        country,
        state,
        telNo,
        ctpatInd,
        hazmatEndorsement,
        licenseNo,
        licenseCountry,
        licenseState,
        cdlNo,
        cdlCountry,
        cdlState,
        routingCode,
        brokerDownloadRefNo,
        portOfLoading,
        firstName,
        middleName,
        lastName,
        aceIdFlag,
        fastCard,
        crewId,
        portCode,
        fastCardFlag,
        saveFlag,
        nationality,

        internationalDoc,
        docType,
        docNo,
        docCountry,
        docState,

        statusNotificationTitle,
        snType,
        shipmentControlNum,
        mobileNum,
        faxNum,

        max100RecordsPerExport,
        exportManifestInBackground,
        exportManifest,
        massDelete,
        massDeleteInProgress,
        massDeleteSuccessMsg
    }
}

export default ACEHighwayManifestTranslationText

